"use client";

import { Button } from "@/components/ui/button";
import { LayoutGrid, List } from "lucide-react";
import type { ViewPreference } from "@/lib/types";
import { cn } from "@/lib/utils";

interface ViewToggleProps {
  view: ViewPreference;
  onViewChange: (view: ViewPreference) => void;
  className?: string;
}

/**
 * Toggle component for switching between card and list views
 */
export function ViewToggle({ view, onViewChange, className }: ViewToggleProps) {
  return (
    <div className={cn("flex items-center gap-1 rounded-lg border p-1", className)}>
      <Button
        variant={view === "card" ? "default" : "ghost"}
        size="sm"
        className="h-8 w-8 p-0"
        onClick={() => onViewChange("card")}
        aria-label="Card view"
        title="Card view"
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant={view === "list" ? "default" : "ghost"}
        size="sm"
        className="h-8 w-8 p-0"
        onClick={() => onViewChange("list")}
        aria-label="List view"
        title="List view"
      >
        <List className="h-4 w-4" />
      </Button>
    </div>
  );
}

